import React, { useState } from 'react'
import _ from 'lodash'
import ClientEditor from './ClientEditor'
import Pager from './Pager'
import TableHeaderSortable from './TableHeaderSortable'
import Tooltip from './Tooltip'
import { rowsPerPage } from '../constants'

let ClientManager = ({ searchVal, clients, sort, setSort, page, setPage }) => {
  const [editingClientIndex, setEditingClientIndex] = useState(-1)
  const [editingNewClient, setEditingNewClient] = useState(false)

  let THSort = ({ children, field }) => {
    return (
      <TableHeaderSortable sort={sort} setSort={setSort} field={field}>
        {children}{' '}
      </TableHeaderSortable>
    )
  }

  const filteredClients = _(clients)
    .filter(c => {
      let lowerSearchVal = _.toLower(searchVal)

      return (
        _.includes(_.toLower(c.id), lowerSearchVal) ||
        _.includes(_.toLower(c.name), lowerSearchVal) ||
        _.some(c.users, user => _.includes(user.email, lowerSearchVal))
      )
    })
    .value()

  return (
    <div>
      {filteredClients[editingClientIndex] && (
        <ClientEditor
          clients={clients}
          client={filteredClients[editingClientIndex]}
          onClose={() => setEditingClientIndex(-1)}
        />
      )}
      {editingNewClient && (
        <ClientEditor
          newClient
          clients={clients}
          client={null}
          onClose={() => setEditingNewClient(false)}
        />
      )}
      <div className="my-2">
        <button
          className="btn btn-sm btn-secondary"
          onClick={() => setEditingNewClient(true)}
        >
          <i className="fa fa-plus" /> New Client
        </button>
      </div>
      <table className="table table-striped table-bordered table-sm small">
        <thead>
          <tr>
            <THSort field="id">ID</THSort>
            <THSort field="name">Name</THSort>
            <th>Billing</th>
            <th>Users</th>
            <th>Phone Mappings</th>
            <th>Form Mappings</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {_(filteredClients)
            .orderBy([c => _.toLower(c[sort.field])], [sort.order])
            .value()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((c, index) => {
              let mappingGroups = _.groupBy(c.parseMappings, 'type')
              let phoneMappingText = _.map(mappingGroups.phone, 'pattern').join(
                ', '
              )
              let formMappingText = _.map(mappingGroups.form, 'pattern').join(
                ', '
              )

              return (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.name}</td>
                  <td>
                    {_.startCase(c.billingType)}
                    {c.billingType === 'perLead' && ` - $${c.pricePerLead}`}
                  </td>
                  <td>
                    {_.map(c.users, u => (
                      <div key={u.email}>
                        {u.name} - {u.phoneNumber} - {u.email}
                      </div>
                    ))}
                  </td>
                  <td>
                    {phoneMappingText && (
                      <Tooltip
                        title={phoneMappingText}
                        width="300px"
                        wrap
                        align="right"
                      >
                        <div>
                          <i className="fa fa-eye" />
                        </div>
                      </Tooltip>
                    )}
                  </td>
                  <td>
                    {formMappingText && (
                      <Tooltip
                        title={formMappingText}
                        width="300px"
                        wrap
                        align="right"
                      >
                        <div>
                          <i className="fa fa-eye" />
                        </div>
                      </Tooltip>
                    )}
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary py-0"
                      onClick={() =>
                        setEditingClientIndex(index + rowsPerPage * page)
                      }
                    >
                      <i className="fa fa-edit" /> Edit
                    </button>
                  </td>
                </tr>
              )
            })}
        </tbody>
      </table>
      <Pager
        page={page}
        pageCount={Math.ceil(filteredClients.length / rowsPerPage)}
        setPage={setPage}
      />
    </div>
  )
}

export default ClientManager
